import React from 'react';
import { CurrencyProvider } from './contexts/CurrencyContext';
import { useMetaPixel } from './hooks/useMetaPixel';
import { HeroSection } from './components/HeroSection';
import { TicketDivider } from './components/TicketDivider';
import { PainSection } from './components/PainSection';
import { MemorySection } from './components/MemorySection';
import { ProductReveal } from './components/ProductReveal';
import { MechanismSection } from './components/MechanismSection';
import { AudienceSection } from './components/AudienceSection';
import { AfterSection } from './components/AfterSection';
import { WhatYouGet } from './components/WhatYouGet';
import { PricingSection } from './components/PricingSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
function AppContent() {
  useMetaPixel();
  return <main className="min-h-screen w-full bg-[#FDF8F4] overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />

      <TicketDivider data-id="element-2" />
      <PainSection data-id="element-3" />

      <TicketDivider data-id="element-4" />
      <MemorySection data-id="element-5" />

      <ProductReveal data-id="element-6" />

      <TicketDivider data-id="element-7" />
      <MechanismSection data-id="element-8" />

      <AudienceSection data-id="element-9" />

      <TicketDivider data-id="element-10" />
      <AfterSection data-id="element-11" />

      <WhatYouGet data-id="element-12" />

      <TicketDivider data-id="element-13" />
      <PricingSection data-id="element-14" />

      <FinalCTA data-id="element-15" />

      <Footer data-id="element-16" />

      <SocialProofToast data-id="element-17" />
    </main>;
}
export function App() {
  return <CurrencyProvider data-id="element-18">
      <AppContent data-id="element-19" />
    </CurrencyProvider>;
}